const tagsLists = [];
let comflag;
export default{
	tagsLists,
	comflag
}